export default "__VITE_ASSET__a9fe6ee4__"